import Vue from 'vue';
import WorkExpandableX from '@/components/global_components/expandables/WorkExpandableX';
import WorkExpandableY from "@/components/global_components/expandable/WorkExpandableY";

Vue.component('WExpandableX', WorkExpandableX);
Vue.component('WExpandableY', WorkExpandableY);
